export const M1_UNIT_8 = {
  id: "u8-talking-things",
  title: "Unidad 8: Talking About Your Things",
  topic: "These/Those & Possessive Pronouns",
  iconType: "boxes",
  grammarImage: "/u8-these-those.jpg",
  grammarText: "Uso de These/Those para plurales y pronombres posesivos (mine, yours, hers, ours, theirs).",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: THIS vs THESE (Near)
    // Enfoque: Singular vs plural + is/are.
    // ----------------------------------------------------------------------
    {
      id: "u8-set1",
      title: "Set 1: Here (Near)",
      questions: [
        {
          type: "match",
          q: "Match Singular and Plural (Near)",
          pairs: [
            { left: "This is", right: "One thing (singular)" },
            { left: "These are", right: "More than one (plural)" },
            { left: "Here", right: "Close to me" }
          ],
          a: "completed"
        },

        { type: "mc", q: "(In my hand) ___ is my phone.", options: ["This", "These", "Those"], a: "This" },
        { type: "mc", q: "(In my hands) ___ are my sunglasses.", options: ["This", "These", "That"], a: "These" },

        { type: "input", q: "Look at ___ photo in my hand. (singular)", a: "this", alts: ["This"] },
        { type: "input", q: "___ are my new shoes. (plural)", a: "these", alts: ["These"] },

        { type: "order", q: "Ordena", words: ["These", "are", "my", "keys."], a: "These are my keys." },

        { type: "mc", q: "___ are our tickets. (near)", options: ["These", "This", "That"], a: "These" },

        // +3 para protocolo (10)
        { type: "mc", q: "Near me: ___ is my notebook.", options: ["This", "These", "Those"], a: "This" },
        { type: "input", q: "Near me: ___ are my books.", a: "these", alts: ["These"] },
        { type: "order", q: "Ordena", words: ["This", "is", "my", "bag."], a: "This is my bag." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: THAT vs THOSE (Far)
    // Enfoque: Distancia + singular/plural.
    // ----------------------------------------------------------------------
    {
      id: "u8-set2",
      title: "Set 2: There (Far)",
      questions: [
        {
          type: "match",
          q: "Match Singular and Plural (Far)",
          pairs: [
            { left: "That is", right: "One thing (singular)" },
            { left: "Those are", right: "More than one (plural)" },
            { left: "Over there", right: "Far away" }
          ],
          a: "completed"
        },

        { type: "mc", q: "(Over there) ___ is my house.", options: ["That", "Those", "These"], a: "That" },
        { type: "mc", q: "(Over there) ___ are your friends.", options: ["That", "Those", "This"], a: "Those" },

        { type: "input", q: "Look at ___ car across the street. (singular)", a: "that", alts: ["That"] },
        { type: "input", q: "___ are beautiful flowers in the garden. (plural)", a: "those", alts: ["Those"] },

        { type: "order", q: "Ordena", words: ["That", "is", "her", "laptop."], a: "That is her laptop." },

        { type: "mc", q: "___ boys are playing football. (far)", options: ["Those", "That", "This"], a: "Those" },

        // +3 para protocolo (10)
        { type: "mc", q: "Across the room: ___ is the teacher.", options: ["That", "Those", "These"], a: "That" },
        { type: "input", q: "Over there: ___ are my parents.", a: "those", alts: ["Those"] },
        { type: "order", q: "Ordena", words: ["Those", "are", "my", "shoes."], a: "Those are my shoes." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: IS vs ARE (Agreement)
    // Enfoque: Concordancia sin explicación larga.
    // ----------------------------------------------------------------------
    {
      id: "u8-set3",
      title: "Set 3: Is or Are?",
      questions: [
        { type: "mc", q: "These ___ my parents.", options: ["are", "is", "am"], a: "are" },
        { type: "mc", q: "That ___ a dictionary.", options: ["is", "are", "am"], a: "is" },
        { type: "input", q: "Those ___ not my shoes. (verb)", a: "are" },

        {
          type: "match",
          q: "Match the start to the end",
          pairs: [
            { left: "This is", right: "an apple" },
            { left: "These are", right: "apples" },
            { left: "That is", right: "my car" }
          ],
          a: "completed"
        },

        { type: "order", q: "Ordena", words: ["Those", "are", "big", "boxes."], a: "Those are big boxes." },
        { type: "input", q: "___ are very expensive glasses. (plural/near)", a: "these", alts: ["These"] },
        { type: "mc", q: "___ is a good book.", options: ["This", "These", "Those"], a: "This" },

        // +3 para protocolo (10)
        { type: "mc", q: "This ___ my phone.", options: ["is", "are", "am"], a: "is" },
        { type: "mc", q: "Those ___ not mine.", options: ["is", "are", "am"], a: "are" },
        { type: "order", q: "Ordena", words: ["These", "are", "my", "friends."], a: "These are my friends." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: PLURAL SPELLING RULES
    // Enfoque: S / ES / IES
    // ----------------------------------------------------------------------
    {
      id: "u8-set4",
      title: "Set 4: Plurals (Spelling)",
      questions: [
        {
          type: "match",
          q: "Singular to Plural",
          pairs: [
            { left: "One book", right: "Two books" },
            { left: "One watch", right: "Two watches" },
            { left: "One dictionary", right: "Two dictionaries" }
          ],
          a: "completed"
        },

        { type: "mc", q: "I have two ___.", options: ["brushes", "brushs", "brush"], a: "brushes" },
        { type: "input", q: "One box. Three ___.", a: "boxes" },
        { type: "mc", q: "There are four ___ on the table.", options: ["dictionaries", "dictionarys", "dictionary"], a: "dictionaries" },

        { type: "input", q: "I love these ___ (sandwich).", a: "sandwiches" },
        { type: "order", q: "Ordena", words: ["I", "have", "two", "watches."], a: "I have two watches." },
        { type: "input", q: "Look at those ___ (baby).", a: "babies" },

        // +3 para protocolo (10)
        { type: "mc", q: "Choose the correct plural: two ___.", options: ["boxes", "boxs", "box"], a: "boxes" },
        { type: "mc", q: "Choose the correct plural: three ___.", options: ["watches", "watchs", "watch"], a: "watches" },
        { type: "input", q: "One dictionary, two ___.", a: "dictionaries" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: DETERMINERS vs PRONOUNS
    // Enfoque: my vs mine / your vs yours / her vs hers
    // ----------------------------------------------------------------------
    {
      id: "u8-set5",
      title: "Set 5: My vs Mine",
      questions: [
        {
          type: "match",
          q: "Match the meaning",
          pairs: [
            { left: "It is my book", right: "The book is mine" },
            { left: "It is your car", right: "The car is yours" },
            { left: "It is her cat", right: "The cat is hers" }
          ],
          a: "completed"
        },

        { type: "mc", q: "This is MY bag. It is ___.", options: ["mine", "my", "me"], a: "mine" },
        { type: "mc", q: "Is this YOUR phone? Yes, it is ___.", options: ["yours", "your", "you"], a: "yours" },

        { type: "input", q: "This is not my key. It is ___. (your key)", a: "yours" },
        { type: "order", q: "Ordena", words: ["This", "laptop", "is", "mine."], a: "This laptop is mine." },

        { type: "mc", q: "That is HER purse. It is ___.", options: ["hers", "her", "she"], a: "hers" },
        { type: "input", q: "Those shoes aren't mine. They are ___. (her shoes)", a: "hers" },

        // +3 para protocolo (10)
        { type: "input", q: "That is your wallet. It is ___.", a: "yours" },
        { type: "mc", q: "This is my notebook. The notebook is ___.", options: ["mine", "my", "me"], a: "mine" },
        { type: "order", q: "Ordena", words: ["That", "phone", "is", "yours."], a: "That phone is yours." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: PRONOUNS (His, Ours, Theirs)
    // Enfoque: ours/theirs + his.
    // ----------------------------------------------------------------------
    {
      id: "u8-set6",
      title: "Set 6: Ours & Theirs",
      questions: [
        {
          type: "match",
          q: "Connect the owners",
          pairs: [
            { left: "Belongs to him", right: "his" },
            { left: "Belongs to us", right: "ours" },
            { left: "Belongs to them", right: "theirs" }
          ],
          a: "completed"
        },

        { type: "mc", q: "This house belongs to us. It is ___.", options: ["ours", "our", "us"], a: "ours" },
        { type: "mc", q: "That dog belongs to them. It is ___.", options: ["theirs", "their", "they"], a: "theirs" },

        { type: "input", q: "Is this John's? Yes, it is ___.", a: "his" },
        { type: "order", q: "Ordena", words: ["Those", "sandwiches", "are", "ours."], a: "Those sandwiches are ours." },

        { type: "mc", q: "We bought this car. It is ___.", options: ["ours", "our", "us"], a: "ours" },
        { type: "input", q: "They own that garden. It is ___.", a: "theirs" },

        // +3 para protocolo (10)
        { type: "mc", q: "That phone belongs to him. It is ___.", options: ["his", "him", "he"], a: "his" },
        { type: "input", q: "These books belong to us. They are ___.", a: "ours" },
        { type: "order", q: "Ordena", words: ["That", "car", "is", "theirs."], a: "That car is theirs." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: OBJECTS & POSSESSION (Contexto)
    // Enfoque: vocab + posesión + this/these/that/those.
    // ----------------------------------------------------------------------
    {
      id: "u8-set7",
      title: "Set 7: Everyday Objects",
      questions: [
        { type: "mc", q: "Whose wallet is this? It is ___.", options: ["Dad's", "Dad", "Dads"], a: "Dad's" },
        { type: "input", q: "I lost my ___. (plural of key)", a: "keys" },

        {
          type: "match",
          q: "Singular vs Plural (demonstratives)",
          pairs: [
            { left: "This wallet", right: "These wallets" },
            { left: "That watch", right: "Those watches" },
            { left: "This dictionary", right: "These dictionaries" }
          ],
          a: "completed"
        },

        { type: "order", q: "Ordena", words: ["These", "are", "Ben's", "keys."], a: "These are Ben's keys." },
        { type: "input", q: "This isn't my phone. Is it ___?", a: "yours" },
        { type: "mc", q: "Those are ___ glasses.", options: ["Sally's", "Sally", "Sallys"], a: "Sally's" },
        { type: "input", q: "I have two ___ (brush) in my bag.", a: "brushes" },

        // +3 para protocolo (10)
        { type: "mc", q: "Near me: ___ are my earphones.", options: ["These", "Those", "That"], a: "These" },
        { type: "input", q: "Over there: ___ is my laptop.", a: "that", alts: ["That"] },
        { type: "order", q: "Ordena", words: ["Those", "are", "my", "parents'", "bags."], a: "Those are my parents' bags." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: MIXED CHALLENGE
    // Enfoque: Escritura y selección rápida.
    // ----------------------------------------------------------------------
    {
      id: "u8-set8",
      title: "Set 8: Mixed Practice",
      questions: [
        { type: "mc", q: "___ are my friends over there.", options: ["Those", "These", "This"], a: "Those" },
        { type: "input", q: "This is my pen. It is ___.", a: "mine" },
        { type: "mc", q: "___ is your passport here.", options: ["This", "That", "These"], a: "This" },

        { type: "order", q: "Ordena", words: ["The", "red", "car", "is", "theirs."], a: "The red car is theirs." },
        { type: "input", q: "Look at ___ birds in the sky. (plural/far)", a: "those", alts: ["Those"] },

        // Mantengo tu idea de irregular plural, pero lo hago 100% directo:
        { type: "mc", q: "Correct plural: child -> ___.", options: ["children", "childs", "child"], a: "children" },

        { type: "input", q: "That isn't your seat. It is ___. (mine)", a: "mine" },

        // +3 para protocolo (10)
        { type: "mc", q: "Near me: ___ are my keys.", options: ["These", "Those", "That"], a: "These" },
        { type: "input", q: "This is not her bag. It is ___.", a: "yours" },
        { type: "order", q: "Ordena", words: ["Those", "flowers", "are", "beautiful."], a: "Those flowers are beautiful." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: CONVERSATION BUILDER (10)
    // ----------------------------------------------------------------------
    {
      id: "u8-set9",
      title: "Set 9: Dialogue",
      questions: [
        { type: "order", q: "Question", words: ["Whose", "bag", "is", "this?"], a: "Whose bag is this?" },
        { type: "order", q: "Answer", words: ["It", "is", "mine."], a: "It is mine." },

        { type: "mc", q: "Is this yours?", options: ["No, it's hers.", "No, it's her.", "No, its hers."], a: "No, it's hers." },

        { type: "input", q: "Are these your keys? Yes, they are ___. (mine)", a: "mine" },

        {
          type: "match",
          q: "Match Question to Answer",
          pairs: [
            { left: "Is this yours?", right: "Yes, it is mine." },
            { left: "Are these his?", right: "No, they are hers." },
            { left: "Whose is that?", right: "It is John's." }
          ],
          a: "completed"
        },

        // +5 para protocolo (10)
        { type: "order", q: "Question", words: ["Are", "these", "yours?"], a: "Are these yours?" },
        { type: "order", q: "Answer", words: ["Yes,", "they", "are", "mine."], a: "Yes, they are mine." },

        { type: "mc", q: "Choose the correct reply: Whose phone is that?", options: ["It's theirs.", "It's their.", "It's them."], a: "It's theirs." },

        { type: "input", q: "Short answer: Are those your books? No, they are ___. (hers)", a: "hers" },

        { type: "order", q: "Answer", words: ["This", "wallet", "is", "mine."], a: "This wallet is mine." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: MASTERY (10)
    // ----------------------------------------------------------------------
    {
      id: "u8-set10",
      title: "Set 10: Review Challenge",
      questions: [
        { type: "input", q: "Singular: box. Plural: ___.", a: "boxes" },

        { type: "mc", q: "___ books (near) are heavy.", options: ["These", "Those", "This"], a: "These" },

        { type: "order", q: "Complex Sentence", words: ["This", "book", "is", "mine."], a: "This book is mine." },

        // Ajuste: la frase estaba rara; ahora es directa
        { type: "input", q: "That is not our car. ___ is red. (ours)", a: "ours", alts: ["Ours"] },

        {
          type: "match",
          q: "Ultimate Check",
          pairs: [
            { left: "My -> Mine", right: "Possessive pronoun" },
            { left: "This -> These", right: "Plural (near)" },
            { left: "That -> Those", right: "Plural (far)" }
          ],
          a: "completed"
        },

        { type: "mc", q: "She has three ___ (dictionary).", options: ["dictionaries", "dictionarys"], a: "dictionaries" },

        { type: "input", q: "I like ___ shoes. (near)", a: "these", alts: ["These"] },

        { type: "order", q: "Final", words: ["Those", "are", "not", "yours."], a: "Those are not yours." },

        // +2 para protocolo (10)
        { type: "mc", q: "That bag belongs to her. It is ___.", options: ["hers", "her", "she"], a: "hers" },
        { type: "input", q: "These keys belong to them. They are ___.", a: "theirs" }
      ]
    }
  ]
};
